/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { NgModule } from '@angular/core';
import { CommonExternalSharedModule } from '@gh/common-external-shared';
import { UserContext } from '@gh/common-shared';
import { SupplierUserContext, SupplierUserContextService, SupplierUserProfileStore } from './user';
import * as i0 from "@angular/core";
import * as i1 from "../common-external-shared/common-external-shared.module";
var SupplierSharedModule = /** @class */ (function () {
    function SupplierSharedModule() {
    }
    SupplierSharedModule.forRoot = function () {
        return {
            ngModule: SupplierSharedModule,
            providers: [
                { provide: SupplierUserContext, useClass: SupplierUserContextService },
                { provide: UserContext, useExisting: SupplierUserContext },
                SupplierUserProfileStore,
            ],
        };
    };
    SupplierSharedModule.forChild = function () {
        return {
            ngModule: SupplierSharedModule,
            providers: [],
        };
    };
    SupplierSharedModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierSharedModule });
    SupplierSharedModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierSharedModule_Factory(t) { return new (t || SupplierSharedModule)(); }, imports: [[
                CommonExternalSharedModule.forChild(),
            ],
            CommonExternalSharedModule] });
    return SupplierSharedModule;
}());
export { SupplierSharedModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierSharedModule, { imports: [i1.CommonExternalSharedModule], exports: [CommonExternalSharedModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierSharedModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonExternalSharedModule.forChild(),
                ],
                declarations: [],
                exports: [
                    CommonExternalSharedModule,
                ],
            }]
    }], null, null); })();
